
import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import classNames from 'classnames';

const ProfileDropdown = ({ profilePic = null, username, userTitle, menuItems }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = useCallback(() => {
        setDropdownOpen(prev => !prev);
    }, []);

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle
                tag="button"
                className="nav-link dropdown-toggle nav-user me-0"
                aria-expanded={dropdownOpen}
            >
                <div className="d-flex align-items-center">
                    <span className="account-user-avatar me-2">
                        <img 
                            src={profilePic} 
                            className="rounded-circle" 
                            alt="user" 
                            width="32"
                            height="32"
                        />
                    </span>
                    <div className="d-none d-md-block text-start">
                        <span className="account-user-name d-block">{username}</span>
                        {userTitle && (
                            <small className="account-user-title text-muted">{userTitle}</small>
                        )}
                    </div>
                    <i className={classNames(
                        'fas fa-chevron-down ms-2 text-muted',
                        { 'fa-rotate-180': dropdownOpen }
                    )}></i>
                </div>
            </DropdownToggle>
            <DropdownMenu 
                end 
                className="dropdown-menu-animated topbar-dropdown-menu profile-dropdown"
            >
                <div>
                    <div className="dropdown-header noti-title">
                        <h6 className="text-overflow m-0">Welcome!</h6>
                    </div>
                    {menuItems.map((item, i) => (
                        <Link
                            to={item.redirectTo}
                            className="dropdown-item notify-item"
                            key={i + '-profile-menu'}
                            onClick={toggleDropdown}
                        >
                            <i className={classNames(item.icon, 'me-2')}></i>
                            <span>{item.label}</span>
                        </Link>
                    ))}
                </div>
            </DropdownMenu>
        </Dropdown>
    );
};

export default ProfileDropdown;
